"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var Products = function Products(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M65 49H29v24h36V49zm2.5-7H70a2 2 0 0 1 2 2v34a2 2 0 0 1-2 2H24a2 2 0 0 1-2-2V44c0-.552.224-1.052.586-1.414A1.994 1.994 0 0 1 24 42h43.5zM79 8H15v20h64V8zm1.5-5H82a2 2 0 0 1 2 2v86a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h68.5zM79 88V35H15v53h64zM26 15h6a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zm19 0h6a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zm19 0h6a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2z",
    fill: "currentColor"
  })));
};
var _default = exports.default = Products;